<!-- 余额 -->
<template>
    <div class="wallet">
        <div class="wallet-header">
            <div class="wallet-header-img">
                <div class="title">{{ !gold.registerSendMoney ? "我的余额(元)" : "体验金余额(元)" }}</div>
                <div class="num">{{ Number(walletBalance).toFixed(2) }}</div>
            </div>

            <van-button v-if="isRecharge" @click="toRecharge" class="wallet-header-button">充值</van-button>

            <div v-if="gold.registerSendMoney" class="date-container">
                <div class="top">
                    <span> 赠送您体验金{{ gold.registerSendMoney }}元 </span> <img @click="showAnswer" src="@/assets/images/mine/question.png" alt="" />
                </div>
                <div class="bottom">有效期：{{ gold.beginTime.split(" ")[0] }} ~ {{ gold.endTime.split(" ")[0] }}</div>
            </div>
        </div>

        <div class="wallet-container">
            <date-picker :isFixed="false" :date.sync="query.billDate" type="year-month" title="选择年月">
                <template #left>
                    <div class="wallet-container-header flex align-center">
                        <img src="@/assets/images/mine/balance.png" alt="" />
                        <span>账单明细</span>
                    </div>

                    <div class="wallet-site flex align-center">
                        <span class="text-cut wallet-site-name" @click="changeType">{{ typeName }}</span> <van-icon name="arrow-down" />
                    </div>
                </template>
            </date-picker>
            <lazy-load-list :getData="initData" :description="'暂无消费明细'" :query="query">
                <template v-slot="slotData">
                    <div class="bill-list">
                        <div class="bill-list-item flex align-center" v-for="(item, index) in slotData.dataList" :key="index">
                            <div class="bill-list-item-left flex">
                                <!-- <img v-if="item.orderType == 1" src="@/assets/images/mine/weChar.png" alt="" /> -->
                                <img v-if="item.orderType == 2 || item.orderType == 6" src="@/assets/images/mine/parking.png" alt="" />
                                <img v-if="item.orderType == 1" src="@/assets/images/mine/arrears.png" alt="" />
                                <img v-if="item.orderType == 8" src="@/assets/images/mine/market.png" alt="" />
                                <div>
                                    <div class="left-container">
                                        <span v-if="item.orderType == 1">余额充值</span>
                                        <span v-else-if="item.orderType == 2">路内停车缴费</span>
                                        <span v-else-if="item.orderType == 3">预约缴费</span>
                                        <span v-else-if="item.orderType == 4">预约超时缴费</span>
                                        <span v-else-if="item.orderType == 5">停车预缴</span>
                                        <span v-else-if="item.orderType == 6">路外停车缴费</span>
                                        <span v-else-if="item.orderType == 7">会员升级费用</span>
                                        <span v-else-if="item.orderType == 8">月卡购买</span>

                                        -
                                        <span v-if="item.payChannel == 1">余额支付</span>
                                        <span v-else-if="item.payChannel == 2">微信支付</span>
                                        <span v-else-if="item.payChannel == 3">支付宝</span>
                                        <span v-else-if="item.payChannel == 4">线下支付</span>
                                        <span v-else-if="item.payChannel == 5">访客代付</span>
                                        <span v-else-if="item.payChannel == 6">莆田一卡通支付</span>
                                        <span v-else-if="item.payChannel == 7">建行支付</span>
                                        <span v-else-if="item.payChannel == 8">农行支付</span>
                                        <span v-else-if="item.payChannel == 9">畅捷支付</span>
                                        <span v-else-if="item.payChannel == 11">泉州银行</span>
                                        <span v-else-if="item.payChannel == 12">翼支付</span>
                                        <span v-else-if="item.payChannel == 66">金融支付</span>
                                    </div>
                                    <div class="time">{{ item.payTime }}</div>
                                </div>
                            </div>
                            <div class="bill-list-item-right">
                                <div v-if="item.orderType == 1">+{{ Number(item.orderMoney).toFixed(2) }}</div>
                                <div v-else-if="item.orderType != 1">-{{ Number(item.orderMoney).toFixed(2) }}</div>

                                <!-- <div>充值 - 微信支付</div> -->
                            </div>
                        </div>
                    </div>
                </template>
            </lazy-load-list>
        </div>

        <van-action-sheet v-model="showDatePick">
            <div class="content">
                <van-picker title="选择交易类型" show-toolbar value-key="name" :columns="typeList" @confirm="typeOnConfirm" @cancel="typeOnCancel" @change="typeOnChange" />
            </div>
        </van-action-sheet>
        <!-- 收费规则弹出 -->
        <div class="toll-rule-dialog">
            <van-dialog v-model="showTollRule" :showConfirmButton="false">
                <div class="toll-rule-wrap">
                    <div class="toll-rule-wrap-header flex justify-between">
                        <p>规则说明</p>
                        <img src="@/assets/images/parking/parking-close.png" alt="" @click="showTollRule = false" />
                    </div>
                    <div class="toll-rule-item">
                        <div class="toll-rule-item-content">1.赠送的体验金金额为{{ gold.registerSendMoney }}元；</div>
                        <div class="toll-rule-item-content">2.体验金可用于体验收费期间；</div>
                        <div class="toll-rule-item-content">3.体验收费到期后体验金余额将清零。</div>
                    </div>
                </div>
            </van-dialog>
        </div>

        
    </div>
</template>

<script>
import { listMyBill, queryBindPlateNumAndCouponNum, queryCashConfig, updateWalletNofeelPay } from "@/api/api";
import DatePicker from "@/components/base/datePicker/date-picker.vue";
import LazyLoadList from "@/components/base/lazyLoadList/lazy-load-list.vue";
import { Picker } from "vant";

import { obj2Param } from "@/libs/tools";

export default {
    name: "wallet",
    components: {
        DatePicker,
        LazyLoadList,
        "van-picker": Picker,
    },
    data() {
        return {
            walletBalance: "0.00", //用户余额
            payMoney: "0.00", //当月支出
            incomeMoney: "0.00", //当月收入
            query: {
                billDate: "2021-10",
                pageNum: 0,
                pageSize: 10,
                orderType: "",
            },
            typeName: "全部交易类型",

            showDatePick: false,

            showTollRule: false,
            typeList: [
                { id: 0, name: "全部交易类型" },
                { id: 1, name: "余额充值" },
                { id: 2, name: "停车缴费" },
                // { id: 3, name: "预约缴费" },
                // { id: 4, name: "预约超时缴费" },
                // { id: 5, name: "停车预缴" },
                // { id: 6, name: "路外停车缴费" },
                // { id: 7, name: "会员升级费用" },
                { id: 8, name: "月卡购买" },
            ], //

            isRecharge: false, //是否能充值
            gold: {
                beginTime: "",
                endTime: "",
                registerSendMoney: "",
            },
            isWalletAutoPay: false,//钱包无感状态
        };
    },

    computed: {},
    watch: {
        "query.date": {
            handler(newValue, oldValue) {
                this.getBillMoney({ date: newValue, type: this.query.type });
            },
            deep: true,
            immediate: false,
        },
    },
    mounted() {
        this.getWallet();

        queryCashConfig({ type: 99 }).then((res) => {
            this.isRecharge = res.data.status == 1 ? true : false;
        });

        queryCashConfig({ type: 3 }).then((res) => {
            console.log(res);
            if (res.data) {
                this.showTollRule = true;
                let { beginTime, endTime, registerSendMoney } = res.data;
                this.gold = {
                    beginTime,
                    endTime,
                    registerSendMoney,
                };
            }
        });
    },

    methods: {
        //给子组件用
        initData() {
            return listMyBill(this.query);
        },

        //获取余额余额
        getWallet() {
            queryBindPlateNumAndCouponNum({ type: 2 }).then((res) => {
                this.walletBalance = res.data.walletMoney;
            });
        },

        //跳转到充值页面
        toRecharge() {
            this.$router.push({
                name: "Recharge",
            });
        },
        // 选择消费类型
        changeType() {
            this.showDatePick = true;
        },

        typeOnConfirm(value) {
            this.query.orderType = value.id ? value.id : "";
            this.typeName = value.name;
            this.showDatePick = false;
        },
        typeOnCancel() {
            this.showDatePick = false;
        },
        typeOnChange() { },

        // 余额有效期点击事件
        showAnswer() {
            this.showTollRule = true;
        },
        // 钱包自动缴费开关修改事件
        switchWalletAutoPay() {
            updateWalletNofeelPay({
                id: this.settingData.id,
                plateNum: this.settingData.plateNum,
                status: this.settingData.isWalletAutoPay,
            }).then((res) => {
                this.$toast("设置成功!");
                this.getListMyPlateNum();
                this.showSetting = false;
            }).catch(error => {
                this.settingData.isWalletAutoPay = !this.settingData.isWalletAutoPay;
            });
        },

    },
};
</script>
<style lang="less" scoped>
.wallet {
    .wallet-header {
        width: 750px;

        min-height: 240px;
        background-color: #fff;
        padding-top: 16px;
        padding-bottom: 20px;

        text-align: center;
        .wallet-header-img {
            width: 720px;
            height: 240px;
            background: url("~@/assets/images/mine/title.png") no-repeat;
            background-size: 100% 100%;
            margin: 0 auto;
            padding-top: 50px;
            .title {
                color: #fff;
                font-size: 30px;
            }
            .num {
                color: #fff;
                margin-top: 30px;
                font-size: 50px;
            }
        }

        .date-container {
            width: 690px;
            height: 100px;

            margin: 0 auto;
            padding: 12px 0;
            color: #ffa840;
            border-radius: 20px;
            background-color: #fff3e5;
            .top {
                font-size: 30px;
                font-weight: bold;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    width: 30px;
                    height: 30px;
                    margin-left: 10px;
                }
            }
            .bottom {
                font-size: 28px;
            }
        }
        .wallet-header-button {
            // margin: 32px auto 0 auto;
            height: 70px;
            width: 690px;
            background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
            color: #fff;
            border-radius: 10px;
        }
    }

    .wallet-container {
        border-top: 1px solid #dbdada33;
        .wallet-container-header {
            margin-left: 30px;
            color: #666666;
            img {
                width: 32px;
                height: 32px;
                margin-right: 15px;
            }
        }
        .wallet-site {
            margin-right: 10px;
            font-size: 24px;
            color: #666666;
            .wallet-site-name {
                width: 137px;
                text-align: center;
            }
        }

        .wallet-container-middle {
            height: 60px;
            line-height: 60px;
            padding-left: 36px;
            color: #a3a3a3;
        }
    }
}

.bill-list {
    margin-top: 20px;
    .bill-list-item {
        height: 128px;
        padding: 20px;
        border-bottom: 1px solid #dbdada33;
        justify-content: space-between;
        background-color: #fff;
        img {
            height: 70px;
            width: 70px;
            margin-right: 25px;
        }

        .bill-list-item-left {
            .left-container {
                font-size: 30px;
                margin-bottom: 10px;
            }
            .time {
                font-size: 25px;

                color: #999;
            }
        }
        .bill-list-item-right {
            font-size: 40px;
            // border: 1px red solid;
        }
    }
}
.toll-rule-wrap {
    border-radius: 20px;
    background-color: #fff;
    padding-bottom: 30px;

    .toll-rule-wrap-header {
        padding: 32px;
        font-size: 34px;
        border-bottom: 1px solid #d5d5d5;
        color: #212121;

        img {
            width: 40px;
            height: 40px;
        }
    }

    .toll-rule-item {
        padding: 0 30px;
        margin: 30px 0;

        .toll-rule-item-title {
            font-size: 30px;
            color: #212121;
        }

        .toll-rule-item-content {
            font-size: 30px;
            color: #333333;
            margin-top: 10px;
        }
    }
}
</style>
